import { Form, Input, ModalProps, FormProps, Modal, InputNumber, Button, Space, Select, useSelect, Col, Grid, Row } from '@pankod/refine-antd'
import { useGetIdentity, useTable } from '@pankod/refine-core'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { ISection, ITestTrack } from 'interfaces'
import { useState } from 'react'
import { productTypes } from 'utility/product.types'

type CreateProductProps = {
  modalProps: ModalProps
  formProps: FormProps
  findProductCount: () => Promise<void>
}

export const CreateProduct: React.FC<CreateProductProps> = ({ modalProps, formProps, findProductCount }) => {
  const { data: user } = useGetIdentity()
  const [selectedSections, setSelectedSections] = useState<object[]>([])
  const [productType, setProductType] = useState<string>('tq')
  const { tableQueryResult: sectionSelectProps } = useTable<ISection>({
    resource: 'sections',
    metaData: {
      fields: ['id', 'name'],
    },
    initialPageSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const { selectProps: testTrackSelectProps } = useSelect<ITestTrack>({
    resource: 'test_tracks',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    fetchSize: 1000,
    sort: [{ field: 'name', order: 'asc' }],
     filters: [
    {
      field: 'in_use',
      operator: 'eq',
      value: true,
    },
  ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const onFinish = async (values: any) => {
    let total_questions = 0
    let total_marks = 0
    const priorityList =
      values?.type === 'jharkhand'
        ? [
            'Subject Expertise (SE)',
            'Pedagogical Content Knowledge (PCK)',
            'General Pedagogy (GP)',
            'Continuous and Comprehensive Evaluation (CCE)',
            'Teacher Perspectives and Professional Competencies (TP&PC)',
          ]
        : ['Subject Expertise (SE)', 'Pedagogical Content Knowledge (PCK)', 'General Pedagogy (GP)', 'Professional and core competencies (PC)']

    if (values?.sections?.length > 0) {
      values?.sections?.map((item: any) => {
        const getSectionDetails = sectionSelectProps?.data?.data.find(section => section?.id === item?.section_id)
        item.section_name = getSectionDetails?.name
        total_questions += parseInt(item?.no_of_questions)
        total_marks += parseInt(item?.marks)
      })
    }
    //final sorting
    values.sections = values?.sections
      ?.sort((a: any, b: any) => {
        const indexA = priorityList.indexOf(a.section_name)
        const indexB = priorityList.indexOf(b.section_name)
        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB)
      })
      ?.map((section: any) => {
        const { section_name, ...rest } = section 
        return rest
      })
     
    // return (
    //   formProps.onFinish &&
    //   formProps.onFinish({
    //     ...values,
    //     total_questions,
    //     total_marks,
    //   })
    // )
    if (formProps?.onFinish) {
      const response: any = await formProps.onFinish({
        ...values,
        tq: values?.type === 'tq',
        total_questions,
        total_marks,
      })

      if (response?.data?.id) {
        const count = await findProductCount()
      }
    }
  }
  const handleSectionChange = (value: { value: any }) => {
    let arr: object[] = [...selectedSections]
    arr.push(value)
    setSelectedSections(arr)
  }
  const removeSection = () => {
    let arr: object[] = []
    const { sections } = formProps?.form?.getFieldsValue()
    if (sections.length > 0) {
      sections?.map((item: any) => {
        arr.push(item?.section_id)
      })
    }
    setSelectedSections(arr)
  }
  const disabledAddSection = (fields: any): boolean => {
    if (sectionSelectProps?.data?.data !== undefined) {
      if (sectionSelectProps.data.data.length === fields.length) {
        return true
      } else {
        return false
      }
    }
    return false
  }
  const breakpoint = Grid.useBreakpoint()
  return (
    <Modal
      {...modalProps}
      title="Create Product"
      afterClose={() => {
        //reset states
        setSelectedSections([])
        formProps?.form?.resetFields()
      }}
    >
      <Form {...formProps} layout="vertical" onFinish={values => onFinish(values)}>
        <Form.Item
          label="Product Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Subject Track" name="test_track_ids" rules={[{ required: true }]}>
          <Select {...testTrackSelectProps} mode="multiple" />
        </Form.Item>
        <Form.Item label="Product Type" name="type" rules={[{ required: true, message: 'Please choose an product type' }]}>
          <Select placeholder="Select a product type">
            {productTypes.map(productType => (
              <Select.Option value={productType?.value}>{productType?.label}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <h3>Product Paper Format</h3>
        <Form.List name="sections">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Row key={key} gutter={[16, 16]} align="middle">
                    <Col xs={15} sm={9} md={7} lg={9}>
                      <Form.Item
                        {...restField}
                        name={[name, 'section_id']}
                        rules={[{ required: true }]}
                        style={{ width: breakpoint.xs ? 150 : '100%' }}
                      >
                        <Select placeholder="Sections" onChange={value => handleSectionChange(value)}>
                          {sectionSelectProps.data?.data?.map((item: any) => (
                            <option key={item?.id} value={item?.id} hidden={selectedSections.includes(item?.id)}>
                              {item?.name}
                            </option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={3} sm={6} md={6} lg={6}>
                      <Form.Item
                        {...restField}
                        name={[name, 'no_of_questions']}
                        rules={[{ required: true, message: 'Missing No of Questions' }]}
                        style={{ marginBottom: 8 }}
                      >
                        <Input placeholder="No of Questions" />
                      </Form.Item>
                    </Col>
                    <Col xs={3} sm={5} md={6} lg={6}>
                      <Form.Item {...restField} name={[name, 'marks']} rules={[{ required: true, message: 'Missing Marks' }]}>
                        <Input placeholder="Total Marks" />
                      </Form.Item>
                    </Col>

                    <Col xs={3} sm={4} md={5} lg={3}>
                      <MinusCircleOutlined
                        onClick={() => {
                          remove(name)
                          removeSection()
                        }}
                      />
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />} disabled={disabledAddSection(fields)}>
                    Add Section
                  </Button>
                </Form.Item>
              </>
            )
          }}
        </Form.List>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
